import { useTranslation } from 'react-i18next';
import { InboxOutlined } from '@ant-design/icons';
import { Upload } from 'antd';
import { useNotify } from '@/hooks';

export default function UploadFiles({
  uploadName,
  multiple = true,
  onUploaded,
  onSelected,
  fileList,
  allowedFileTypes = 'JPEG, PNG, JPG, GIF, BMP, WEBP, PDF',
  accept = 'image/jpeg,image/png,image/jpg,image/gif,image/bmp,image/webp,application/pdf',
  maxUploadSize = 5,
  maxCount,
  showRemoveIcon = true,
}) {
  const { t } = useTranslation(['messages', 'forms']);
  const notification = useNotify();

  const props = {
    name: uploadName,
    multiple,
    accept: accept === 'all' ? '*/*' : accept,
    maxCount,
    showUploadList: {
      showRemoveIcon,
    },
    beforeUpload(file) {
      const isMaxFileSize = file.size / 1024 / 1024 < maxUploadSize;
      if (!isMaxFileSize) {
        notification.error({
          message: t('error', { ns: 'messages' }),
          description: `File must be smaller than ${maxUploadSize}MB! This file is a problem: ${file.name}`,
        });
        return Upload.LIST_IGNORE;
      }
      return false;
    },
    onChange(info) {
      const { file } = info;

      if (file.status !== 'removed') {
        const rawFile = file.originFileObj || file;

        onUploaded?.({
          action: {
            type: 'upload',
            payload: {
              uid: file.uid || rawFile.uid || Date.now().toString(),
              name: file.name || rawFile.name || rawFile?.originalname || 'file',
              status: 'done',
              originFileObj: rawFile,
            },
          },
        });
        onSelected?.(file);
      } else {
        onUploaded?.({ action: { type: 'remove', payload: file.uid } });
        onSelected?.(null);
      }
    },
    fileList,
  };

  return (
    <div className="h-max">
      <Upload.Dragger {...props}>
        <p className="ant-upload-drag-icon">
          <InboxOutlined />
        </p>
        <p className="ant-upload-text">
          {t('clickOrDragFile', { ns: 'messages' })}
        </p>
        <p className="ant-upload-hint">
          {t(`uploadSupport.${multiple ? 'bulk' : 'single'}`, {
            ns: 'messages',
          })}
        </p>
        <p className="ant-upload-hint">
          <span>{t('allowedFileTypes', { ns: 'messages' })}: </span>
          <strong>
            {allowedFileTypes === 'all'
              ? t('allTypes', { ns: 'forms' })
              : allowedFileTypes}
          </strong>
        </p>
        <p className="ant-upload-hint">
          <span>{t('maximumFileSize', { ns: 'messages' })}: </span>
          <strong>{maxUploadSize}MB</strong>
        </p>
      </Upload.Dragger>
    </div>
  );
}
